import type { Step } from "react-joyride";

export const leaveTypeCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າສ້າງປະເພດລາໃໝ່. ຕື່ມຊື່, ລະຫັດ, ວັນລາສູງສຸດຕໍ່ປີ ແລະ ຕົວເລືອກອື່ນໆ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-type-create-back"]',
    content: "ກັບຄືນສູ່ລາຍການປະເພດລາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-type-create-form"]',
    content: "ຟອມປະເພດລາ. ຕື່ມຄົບແລ້ວບັນທຶກ.",
    placement: "top",
  },
];
